<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" :key="error" class="errors">
        {{ error }}
      </p>
    </div>
    <div :class="{'has-error':errors.paymentPreference}">
      Set the participant's payment preference to
      <select name="paymentPreference" :value="paymentPreference" class="form-control" @change="handleChange">
        <option value="" selected="selected" disabled>
          Select a Payment Preference
        </option>
        <option v-for="pp in config.paymentPreferences" :key="pp" :value="pp">
          {{ pp }}
        </option>
      </select>
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,

    props: {
      paymentPreference: {
        type: String,
        default: "None"
      }
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.paymentPreference) {
          this.errors.paymentPreference = "Please select a payment preference.";
        }

        if (this.config.paymentPreferences.includes(this.paymentPreference) === false) {
          this.errors.paymentPreference = "'" + this.paymentPreference + "' is no longer available.  Please select a valid payment preference.";
        }

        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
